import React from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';
import { parseRichText } from '../../../utils';

const ns = `section-1`;

const Section1 = ({
	contentSection1Image,
	contentSection1Copy,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	const imgUrl = contentSection1Image?.value.split(' | ')[0];

	const parsedCopy = contentSection1Copy !== null ? JSON.parse(contentSection1Copy.value) : null;

	const fallbackAlt = contentSection1Copy !== null && parsedCopy.children.find(el => {
		return el.type === 'heading';
	}).children[0].value;

	const imgAlt = contentSection1Image?.value.split(' | ')[1] || fallbackAlt;

	return (
		<section className={`${ rootClassnames } image-with-text-5050`}>
			<div className={`container`}>
				<div className={'image-with-text-5050__col'}>
					<img src={imgUrl} alt={imgAlt} />
				</div>
				<div className={'image-with-text-5050__col'}>
					{contentSection1Copy && parse(parseRichText(parsedCopy))}
				</div>
			</div>
			<hr />
		</section>
	);
};

export default Section1;
